const scriptPromises = {};

export const loadScriptOnce = (src) => {
  if (scriptPromises[src]) return scriptPromises[src];
  scriptPromises[src] = new Promise((resolve, reject) => {
    const tag = document.createElement("script");
    tag.src = src;
    tag.async = true;
    tag.onload = () => resolve();
    tag.onerror = () => {
      delete scriptPromises[src];
      reject(new Error(`Failed to load ${src}`));
    };
    document.head.appendChild(tag);
  });
  return scriptPromises[src];
};

let youTubeApiPromise = null;

export const loadYouTubeApi = () => {
  if (window.YT && window.YT.Player) return Promise.resolve(window.YT);
  if (youTubeApiPromise) return youTubeApiPromise;
  youTubeApiPromise = new Promise((resolve) => {
    const previousReady = window.onYouTubeIframeAPIReady;
    window.onYouTubeIframeAPIReady = () => {
      if (typeof previousReady === "function") previousReady();
      resolve(window.YT);
    };
    loadScriptOnce("https://www.youtube.com/iframe_api").catch(() => {
      youTubeApiPromise = null;
    });
  });
  return youTubeApiPromise;
};

export const loadVimeoApi = () => {
  if (window.Vimeo && window.Vimeo.Player) return Promise.resolve(window.Vimeo);
  return loadScriptOnce("https://player.vimeo.com/api/player.js").then(() => window.Vimeo);
};
